import React from "react";
import {
    ResponsiveContainer,
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    ReferenceLine,
    Legend,
} from "recharts";
import { redondearDecimales } from "../../../../../../../utility/utils";

const isNotNull = (value) => value !== null && value !== undefined;

// El eje se queda en ±2% mientras los datos quepan, que es como se ha visto
// siempre, y solo se estira cuando alguna variación se sale: con el dominio
// fijo esa línea quedaba fuera del área visible y desaparecía sin ningún aviso
const LIMITE_MINIMO_EJE = 2;

const calcularDominioEje = (data) => {
    const limite = data.reduce((mayor, fila) => {
        const valores = [
            fila.variacion_acopio_lab,
            fila.variacion_liquidado,
            fila.variacion_produccion,
        ].filter(isNotNull);

        return valores.reduce(
            (mayorDeLaFila, valor) => Math.max(mayorDeLaFila, Math.abs(valor)),
            mayor,
        );
    }, LIMITE_MINIMO_EJE);

    const limiteRedondeado = Math.ceil(limite);

    return [-limiteRedondeado, limiteRedondeado];
};

export const GraficaTraslados = ({
    traslados,
    campoEje = "numero_traslado",
    // solo el reporte mensual trae la variación contra producción; en el
    // individual la serie no existe y no se dibuja
    mostrarVariacionProduccion = false,
}) => {
    const data = traslados.map((traslado) => ({
        categoria: traslado[campoEje],
        variacion_acopio_lab: isNotNull(traslado.variacion_acopio_lab)
            ? redondearDecimales(traslado.variacion_acopio_lab * 100, 2)
            : null,
        variacion_liquidado: isNotNull(traslado.variacion_liquidado)
            ? redondearDecimales(traslado.variacion_liquidado * 100, 2)
            : null,
        variacion_produccion: isNotNull(traslado.variacion_produccion)
            ? redondearDecimales(traslado.variacion_produccion * 100, 2)
            : null,
    }));

    return (
        <div
            style={{
                width: "100%",
                height: 420,
                marginBottom: 5,
            }}
        >
            <ResponsiveContainer>
                <LineChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 30,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                        dataKey="categoria"
                        interval={0}
                        angle={-45}
                        textAnchor="end"
                        height={70}
                    />

                    <YAxis
                        domain={calcularDominioEje(data)}
                        tickFormatter={function (value) {
                            return value + "%";
                        }}
                    />

                    {/* Línea horizontal del 0 */}
                    <ReferenceLine y={0} stroke="#000" strokeWidth={2} />

                    <Tooltip
                        formatter={function (value) {
                            return value + "%";
                        }}
                    />

                    <Legend />

                    <Line
                        type="linear"
                        dataKey="variacion_acopio_lab"
                        stroke="#1976D2"
                        strokeWidth={4}
                        dot={{ r: 6 }}
                        activeDot={{ r: 7 }}
                        name="Variación Acopio"
                        connectNulls
                    />

                    <Line
                        type="linear"
                        dataKey="variacion_liquidado"
                        stroke="#E53935"
                        strokeWidth={4}
                        dot={{ r: 6 }}
                        activeDot={{ r: 7 }}
                        name="Variación Liquidación"
                        connectNulls
                    />

                    {mostrarVariacionProduccion && (
                        <Line
                            type="linear"
                            dataKey="variacion_produccion"
                            stroke="#43A047"
                            strokeWidth={4}
                            dot={{ r: 6 }}
                            activeDot={{ r: 7 }}
                            name="Variación Producción"
                            connectNulls
                        />
                    )}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};
